import { mapValues, values } from 'lodash';
import { HoaFeesTaskFields_hoaAmenities } from 'sellDirect/helpers/__generated__/HoaFeesTaskFields';

export interface IHoaAmenities {
  [amenity: string]: boolean;
}

export const Amenities: { [amenity: string]: string } = {
  'Trash/Recycling': 'hoa_trash_recycling',
  Pool: 'hoa_pool',
  Park: 'hoa_park',
  'Dog Park': 'hoa_dog_park',
  Gym: 'hoa_gym',
  Sauna: 'hoa_sauna',
  'Tennis courts': 'hoa_tennis_courts',
  Clubhouse: 'hoa_clubhouse',
  'Golf Course': 'hoa_golf_course',
  Trails: 'hoa_trails',
  'Sports courts': 'hoa_sports_courts',
  Other: 'hoa_other',
};

export type Amenity = keyof typeof Amenities;

type HoaAmenitiesKey = keyof HoaFeesTaskFields_hoaAmenities;
export type UsableHoaAmenitiesKey = Exclude<HoaAmenitiesKey, 'otherInfo' | '__typename'>;

// map of hoa amenities keys => display titles
// (used by HoaDetailsForm)
export const HoaAmenities: { [k in UsableHoaAmenitiesKey]: string } = {
  trashRecycling: 'Trash / recycling',
  pool: 'Pool',
  park: 'Park',
  dogPark: 'Dog park',
  gym: 'Gym',
  sauna: 'Sauna',
  tennisCourt: 'Tennis courts',
  clubhouse: 'Clubhouse',
  golf: 'Golf course',
  trails: 'Trails',
  sportsCourts: 'Sports courts',
  other: 'Other',
};

export const HoaAmenitiesOptions = values(
  mapValues(HoaAmenities, (key, value) => {
    return { id: `hoaAmenities-${value}`, label: key, value };
  }),
);
